export default __webpack_public_path__ + "static/media/resources.98436a1e.wav";